/** Localization Types  */
export enum LocalizationType {
  INITIAL_LANG = "en",
  SELECTED_LANG = "selectedLanguage",
  DEFAULT_LANG_LOCAL = "en-EN",
}
